import Head from "next/head";
import ContactInfo from "../../components/about/ContactInfo";
import FormContact from "../../components/about/FormContact";
import Loading from "../../components/Loading";
import useContact from "../../service/about/useContact";

export default function Kontak() {
  const { data, setData, isLoading, submit, fetching } = useContact();

  return (
    <main className="h-full w-full">
      <Head>
        <title>Kontak | Wardaya Online by Wardaya College</title>
      </Head>
      <div className="w-full bg-[#F3F7FA] pt-24 lg:pt-36">
        <div className="mx-auto max-w-[1260px] gap-8 px-5">
          <h1 className="font-[Poppins] text-2xl font-bold text-[#1C1C1C] text-opacity-30 lg:text-5xl">
            CONTACT US
          </h1>
          <div className="flex flex-col items-center justify-between lg:flex-row">
            <FormContact data={data} setData={setData} submit={submit} />

            <ContactInfo />
          </div>
        </div>
      </div>

      {isLoading || fetching ? (
        <div className="fixed top-0 left-0 z-[150] flex h-screen w-screen items-center justify-center bg-black bg-opacity-10">
          <Loading fillcolor={"#EA374C"} />
        </div>
      ) : null}
    </main>
  );
}
